import React from 'react'
import CV from '../../assets/emv-cv.pdf'

const CTA = () => {
  return (
    <div className='cta'>
        <a href={CV} download className='btn'>CV indir</a>
        <a href='#contact' className='btn btn-primary'>Bana Ulaş</a>
    </div>
  )
}

export default CTA